import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LevelLinkageComponent } from './level-linkage.component';
import { LevelLinkageService } from './level-linkage.service'

import { CategoryOptionService } from '../../job/category-option/category-option.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [LevelLinkageComponent ],
  exports: [LevelLinkageComponent ],
  providers:[LevelLinkageService,CategoryOptionService],

})
export class LevelLinkageModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/level-linkage/level-linkage.module.ts